<template>
  <q-input
    inverted-light
    class="time-tracking__input"
    color="transparent"
    :value="description"
    :placeholder="$t('working_on')"
    @input="handleInput"
    @focus="handleFocus"
    @blur="handleBlur"
    @keydown="__keyboardHandleKey"
  >
    <q-popover
      ref="popover"
      v-model="popover"
      no-focus
      no-refocus
      keep-on-screen
      max-height="300px"
      class="time-tracking__input__recent__popover"
      :anchor-click="false"
    >
      <div>
        <div
          v-for="(timeEntry, index) in timeEntries"
          class="time-tracking__input__recent__entry q-px-md q-py-sm"
          :class="{ 'active': keyboardIndex === index }"
          :key="timeEntry.id"
          @click="handleSelectSuggestedTimeEntry(timeEntry)"
        >
          <div class="row justify-between items-center gutter-x-md no-wrap">
            <div class="col-auto">
              <div
                class="q-subheading text-dark block ellipsis q-py-sm"
                :class="{ 'text-italic': !timeEntry.description }"
              >
                {{ timeEntry.description || $t('no_description') }}
              </div>
            </div>

            <div v-if="timeEntry.project_id" class="col ellipsis">
              <project-indicator :project="timeEntry.project.data"/>
            </div>
          </div>
        </div>
      </div>
    </q-popover>
  </q-input>
</template>

<script>
  import CustomerIndicator from './CustomerIndicator.vue'
  import ProjectIndicator from './ProjectIndicator.vue'
  import { TimeEntriesClient } from 'src/api/TimeEntries'
  import { debounce } from 'quasar'
  import keyboardSelection from 'quasar-framework/src/mixins/keyboard-selection'

  export default {
    props: {
      value: {
        type: String
      }
    },

    data () {
      return {
        description: this.value,
        timeEntries: [],
        popover: false
      }
    },

    computed: {
      hasSuggestions () {
        return !!this.timeEntries.length
      },

      keyboardMaxIndex () {
        return this.timeEntries.length - 1
      }
    },

    methods: {
      handleInput (value) {
        this.$emit('input', value)

        this.suggestTimeEntriesDebounced(value)
      },

      handleFocus () {
        if (this.description) {
          return
        }

        this.suggestTimeEntries(this.description)
      },

      handleBlur () {
        this.popover = false

        this.$emit('blur')
      },

      suggestTimeEntriesDebounced: debounce(function (term) {
        this.suggestTimeEntries(term)
      }, 200),

      suggestTimeEntries (term) {
        return new TimeEntriesClient()
          .include(['customer', 'project'])
          .suggest(term)
          .then(response => {
            this.timeEntries = response.data.data

            this.__keyboardShow(-1)
            this.popover = this.hasSuggestions
          })
      },

      handleSelectSuggestedTimeEntry (timeEntry) {
        this.$emit('select', {
          description: timeEntry.description,
          billable: timeEntry.billable,
          customerId: timeEntry.customer_id,
          projectId: timeEntry.project_id,
          customer: timeEntry.customer ? timeEntry.customer.data : null,
          project: timeEntry.project ? timeEntry.project.data : null
        })

        this.popover = false
      },

      __keyboardCustomKeyHandle (key) {
        if (!this.popover && key === 13) {
          // Submit on enter
          this.$emit('submit')
        }
      },

      __keyboardShowTrigger () {
        // Do nothing, required for mixin
      },

      __keyboardIsSelectableIndex (index) {
        return index > -1 && index <= this.keyboardMaxIndex
      },

      __keyboardSetSelection (index, navigation) {
        this.handleSelectSuggestedTimeEntry(this.timeEntries[index])
      }
    },

    watch: {
      value (val) {
        this.description = val
      }
    },

    components: {
      CustomerIndicator,
      ProjectIndicator
    },

    mixins: [
      keyboardSelection
    ]
  }
</script>

<style lang="stylus">
  @import '~variables'

  .time-tracking
    &__input
      box-shadow: none !important
      color: $grey-9 !important
      &__recent
        &__entry
          &:hover, &.active
            cursor: pointer
            background-color: $grey-2
        &__popover
          width: 400px
</style>
